export class SpecialEventPopover {
    readonly storageKey: string = 'specialEventPopoverClosed';
    readonly selector: string = '.js-special-event-popover';
    readonly neverShowAfterDate = new Date('2025-01-15T00:00:00.000Z');
    readonly bannerElem: HTMLElement|null = document.querySelector<HTMLElement>(this.selector);
    constructor() {
        window.specialEventSaveClosedState = this.saveClosedState.bind(this);
    }

    private shouldStayClosed(): boolean {
        if (this.eventIsPassed()) {
            return true;
        }

        if (window.localStorage) {
            const expirationDate = window.localStorage.getItem(this.storageKey);
            if (!expirationDate) {
                return false;
            }
            if (JSON.parse(expirationDate) <= new Date().getTime()) {
                window.localStorage.removeItem(this.storageKey);
                return false;
            } else {
                return true;
            }
        }
        return false;
    }

    private eventIsPassed(): boolean {
        return this.neverShowAfterDate < new Date();
    }

    public saveClosedState() {
        if (window.localStorage) {
            window.localStorage.setItem(this.storageKey, JSON.stringify(new Date().getTime()+(10*24*60*60*1000)));
        }
    }

    public show() {
        if (this.bannerElem) {
            if (this.shouldStayClosed()) {
                return;
            }

            document.documentElement.classList.add('is-special-event-popover-active');
            this.bannerElem.classList.add('is-active');
        }
    }
}

declare global {
    interface Window { specialEventSaveClosedState: any; }
}

